import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

export interface MessageDetailState {
    id: string;
    gid: string;
    type: string;
    colorIcon: string;
    title: string;
    subtitle: string;
    promotionText1: string;
    promotionText2: string;
    promotionText3: string;
    promotionText4: string;
    promotionText5: string;
    promotionText6: string;
    promotionText7: string;
    buttonText: string;
    buttonAction: string;
    text1: string;
    text2: string;
    linkText1: string;
    linkUrl1: string;
    linkText2: string;
    linkUrl2: string;
    linkText3: string;
    linkUrl3: string;
}

export function createInitialState(): MessageDetailState {
    return {
        id: '',
        gid: '' /** TODO: No lo uso y Javi tampoco */,
        type: '',
        colorIcon: '',
        title: '',
        subtitle: '',
        promotionText1: '',
        promotionText2: '',
        promotionText3: '',
        promotionText4: '',
        promotionText5: '',
        promotionText6: '',
        promotionText7: '',
        buttonText: '',
        buttonAction: '',
        text1: '',
        text2: '',
        linkText1: '',
        linkUrl1: '',
        linkText2: '',
        linkUrl2: '',
        linkText3: '',
        linkUrl3: '',
    };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'message-detail', resettable: true })
export class MessageDetailStore extends Store<MessageDetailState> {
    constructor() {
        super(createInitialState());
    }
}
